import { render, staticRenderFns } from "./quickReplyBox.vue?vue&type=template&id=2fae6b0e&scoped=true&"
import script from "./quickReplyBox.vue?vue&type=script&lang=js&"
export * from "./quickReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./quickReplyBox.vue?vue&type=style&index=0&id=2fae6b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae6b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
